import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import CodeEditor from "../../Components/CodeEditor";
import { submitForm } from "../../utils/apiUtils";
import { Button } from "reactstrap";

const AddEmailtemplate = () => {
    const location = useLocation();
    const editData = location.state;
    const navigator = useNavigate();
    const [data, setData] = useState({
        name: editData?.name || "",
        subject: editData?.subject || "",
        description: editData?.description || "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData({ ...data, [name]: value });
    };

    const handleUpdate = async (e) => {
        e.preventDefault();
        await submitForm({
            data,
            url: "/emailtemplate",
            editingId: editData?.id,
            navigate: () => navigator("/email-template"),
        });
    };

    return (
        <>
            <div className="content-wrapper">
                <div className="page-header mt-5 mx-4">
                    <h3 className="page-title">Email Template </h3>
                </div>
                <div className="col-md-12 grid-margin stretch-card">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-body">
                                <form className="pt-3" onSubmit={handleUpdate}>
                                    <div className="form-group row">
                                        <label
                                            htmlFor="exampleInputUsername2"
                                            className="col-sm-3 col-form-label font-weight-medium"
                                        >
                                            Email Template Name
                                        </label>
                                        <div className="col-sm-9">
                                            <input
                                                className="form-control form-control-sm "
                                                id="parentCategory"
                                                name="parentCategory"
                                                value={data.name}
                                                readOnly
                                            />
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <label
                                            htmlFor="exampleInputUsername2"
                                            className="col-sm-3 col-form-label font-weight-medium"
                                        >
                                            Subject
                                        </label>
                                        <div className="col-sm-9">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="subject"
                                                name="subject"
                                                placeholder="Enter subject"
                                                value={data.subject}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <label
                                            htmlFor="exampleInputUsername2"
                                            className="col-sm-3 col-form-label font-weight-medium"
                                        >
                                            Description
                                        </label>
                                        <div className="col-sm-9">
                                            <CodeEditor
                                                value={data.description}
                                                placeholder="Enter description ..."
                                                onChange={(value) =>
                                                    handleChange({
                                                        target: {
                                                            name: "description",
                                                            value,
                                                        },
                                                    })
                                                }
                                            />
                                        </div>
                                    </div>

                                    <div className="text-center">
                                        <Link to="/email-template">
                                            <Button color="danger" className="mr-2">Back</Button>
                                        </Link>
                                        <Button type="submit" color="primary">
                                            Submit
                                        </Button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AddEmailtemplate;
